import api from '../base';
import {
  CrossDock,
  ForceDispatchCrossDockRequest,
  ForceDispatchCrossDockResponse,
} from './crossDockTrackingTypes';
import { mockForceDispatchCrossDock, mockGetCrossDocks } from './crossDockMocks';

const BASE_PATH = 'management/cross-docks';
const LOGISTIC_MANAGEMENT_BASE_PATH = 'management/cross-dock';

export async function getCrossDocks(
  signal?: AbortSignal,
): Promise<CrossDock[]> {
  const response = await api.get<CrossDock[]>(
    BASE_PATH,
    {
      signal,
    },
  );
  return response.data;
}

api.mock
  .onGet('management/cross-docks')
  .reply(200, mockGetCrossDocks);

export async function forceDispatchCrossDock(
  request: ForceDispatchCrossDockRequest,
  signal?: AbortSignal,
): Promise<ForceDispatchCrossDockResponse> {
  const response = await api.post<ForceDispatchCrossDockResponse>(
    `${LOGISTIC_MANAGEMENT_BASE_PATH}/dispatch/force`,
    request,
    { signal },
  );
  return response.data;
}

api.mock
  .onPost(`${LOGISTIC_MANAGEMENT_BASE_PATH}/dispatch/force`)
  .reply(207, mockForceDispatchCrossDock);
